import SettingsBadges from '@/components/Dashboard/SettingsBadges';
import SettingsBranding from '@/components/Dashboard/SettingsBranding';
import SettingsCategoriesAndCollections from '@/components/Dashboard/SettingsCategoriesAndCollections';
import SettingsCode from '@/components/Dashboard/SettingsCode';
import SettingsFilters from '@/components/Dashboard/SettingsFilters';
import SettingsTiers from '@/components/Dashboard/SettingsTiers';
import SettingsURLs from '@/components/Dashboard/SettingsURLs';

export const settingsRoutes = [
  {
    path: '/settings',
    name: 'VendorSettings',
    component: () =>
      import(
        /* webpackChunkName: "vendorSettings" */ '@/views/Dashboard/Settings/VendorSettings.vue'
      ),
    children: [
      {
        path: '',
        component: SettingsTiers,
      },
      {
        path: 'tiers',
        components: {
          tiers: SettingsTiers,
        },
      },
      {
        path: 'filters',
        components: {
          filters: SettingsFilters,
        },
      },
      {
        path: 'urls',
        components: {
          urls: SettingsURLs,
        },
      },
      {
        path: 'branding',
        components: {
          branding: SettingsBranding,
        },
      },
      {
        path: 'code',
        components: {
          code: SettingsCode,
        },
      },
      {
        path: 'badges',
        components: {
          badges: SettingsBadges,
        },
      },
      {
        path: 'categoriesAndCollections',
        components: {
          categoriesAndCollections: SettingsCategoriesAndCollections,
        },
      },
    ],
  },
];
